export default __webpack_public_path__ + "static/home-917f905614e42ad5d48f1e38bd49146f.png";